import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FGWService } from '../../services/fgw.service';

@Component({
	selector: 'celine-footer',
	encapsulation: ViewEncapsulation.Emulated,
	template: require('./celine-footer.component.html'),
	styles: [`

    .container-fluid {
      background: #f8f8f8;
    }

    footer {
		border-top: 1px solid #E5E5E5;
		padding: 26px 0;
		font-size: 13px;
		color: #787272;
		height: 88px;
    }

    ul {
    	list-style: none;
    	margin: 0;
    	padding: 0;
    }

    li {
    	display: inline-block;
    	margin-left: 10px;
	}

    a::after {
    	content: "|";
    	margin-left: 10px;
    	color: #787272;
    }

    a:first-child {
    	margin: 0;
    }

    li:last-child a::after {
    	content: "";
    	margin: 0;
    }

    a {
		font-size: 15px;
		color: var(--primary);
		text-decoration: none;
    }

    p.footer__copyright {
    	margin: 0;
		font-size: 15px;
	}

	.copy {
		font-size: 16px;
		position: relative;
		top: 1px;
	}

    .brand {
    	margin-left: 3px;
    }

    `]
})
export class CelineFooterComponent {

	public country: string
	public brand: string;
	public translationTermsHref: any = {};
	public termsHref: string
	public showComplaintsLink: boolean;

	year = new Date().getFullYear();

	private environment: string;

	private complaintsUrl = new Map<string, string>([
	  ["development", "https://web-staging.cib.digital/about-us/complaints/"],
	  ["UAT", "https://web-staging.cib.digital/about-us/complaints/"],
	  ["PPE", "https://cib.absa.africa/about-us/complaints/"],
	  ["PROD", "https://cib.absa.africa/about-us/complaints/"],
	]);


	constructor(private FGWService: FGWService) {

		// get environment variable from api/configuration
		this.environment = JSON.parse(window["__CONFIGURATION"])["environment"] || "LOCAL";

		// complaints link
		this.showComplaintsLink = JSON.parse(window['__CONFIGURATION'])['showComplaintsLink'] ? JSON.parse(window['__CONFIGURATION'])['showComplaintsLink'] : false;

		// country code
		this.country = JSON.parse(window['__CONFIGURATION'])['country'] || 'za';

		if (this.FGWService.getTheme().indexOf('absa') === 0) this.brand = 'Absa'
		else this.brand = 'NBC';

		this.translationTermsHref['absa-bw'] = 'https://www.absa.co.bw/terms-of-use/';
		this.translationTermsHref['absa-gh'] = 'https://www.absa.com.gh/terms-of-use/';
		this.translationTermsHref['absa-ke'] = 'https://www.absabank.co.ke/product-terms-and-conditions/';
		this.translationTermsHref['absa-mu'] = 'https://www.absa.co.mu/en/product-terms-and-conditions/';
		this.translationTermsHref['absa-mz'] = 'https://www.absa.co.mz/pt/product-terms-and-conditions/';
		this.translationTermsHref['absa-sc'] = 'https://www.absa.sc/product-terms-and-conditions/';
		this.translationTermsHref['absa-ug'] = 'https://www.absa.co.ug/terms-of-use/';
		this.translationTermsHref['absa-zm'] = 'https://www.absa.co.zm/terms-of-use/';
		this.translationTermsHref['absa-za'] = 'https://www.absa.co.za/legal-and-compliance/terms-of-use/';
		this.translationTermsHref['absa-tz'] = 'https://www.absa.co.tz/product-terms-and-conditions/';
		this.translationTermsHref['nbc-tz'] = 'http://www.nbc.co.tz/en/terms-and-conditions/';
		this.termsHref = this.translationTermsHref[`${this.brand}-${this.country}`] || this.translationTermsHref[`absa-za`];
	}

	contactUs() {
		window.open(`${JSON.parse(window['__CONFIGURATION'])['authUrl']}/ContactUs`, "_blank");
	}

	supportedBrowsers() {
		window.open(`${JSON.parse(window['__CONFIGURATION'])['authUrl']}/SupportedBrowsers`, "_blank");
	}

	complaints() {
		window.open(this.complaintsUrl.get(this.environment), "_blank").focus();
	}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/celine-footer/celine-footer.component.ts